/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: CurrentPlayersCount.tsx
 *
 * Written by Sterios Taskudis <sterios.taskudis@egt-digital.com> on  25.10.23 2:19 pm.
 * Last modified: 25.10.23 2:19 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Subscription } from 'rxjs';
import { addBuildHash } from '../api/helpers';
import { useLobbyHost } from '../contexts/SettingsContext';
import store from '../eventStore';

const CurrentPlayersCount = ({ gameKey }: ICurrentPlayersCountProps) => {
    const [currentPlayers, setCurrentPlayers] = useState<number>(store.GAMES_CURRENT_PLAYERS.value[gameKey] || 0);
    const { ref, inView } = useInView({ threshold: 0 });
    const host = useLobbyHost();

    useEffect(() => {
        let sub: Subscription;
        if (inView) {
            // Subscribe to the GAMES_CURRENT_PLAYERS in order to display changes if they occur during the polling
            sub = store.GAMES_CURRENT_PLAYERS.subscribe(newPlayersCount => {
                // Optimization: only update the value if it's different than the current one
                if (newPlayersCount[gameKey] === currentPlayers) {
                    return;
                }
                setCurrentPlayers(newPlayersCount[gameKey]);
            });
        }

        return () => {
            sub?.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView, gameKey]);

    return (
        <div ref={ref} className="current_players_container">
            {currentPlayers ? (
                <>
                    <img src={addBuildHash(`${host}/assets/portal/ui/currentPlayers.svg`)} alt="" />
                    <span className="current_players_text">&nbsp;{currentPlayers}</span>
                </>
            ) : null}
        </div>
    );
};

export interface ICurrentPlayersCountProps {
    gameKey: string;
}

export default CurrentPlayersCount;
